export default {"src":"/_next/static/media/nakhelLogo.0199aed7.svg","height":39,"width":36,"blurWidth":0,"blurHeight":0};